import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import LocalizedDateTime from "@insite/content-library/Components/LocalizedDateTime";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

export interface OrderDateStyles {
    wrapper?: GridItemProps;
    titleText?: TypographyProps;
    orderDate?: TypographyProps;
}

export const orderDateStyles: OrderDateStyles = {
    wrapper: {
        css: css`
            padding-bottom: 10px;
        `,
    },
    titleText: {
        variant: "h3",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
            font-size: 16px;
        `,
    },
};

const styles = orderDateStyles;

const OrderType: FC = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order) {
        return null;
    }
    const isEmergencyOrder = order.properties?.isEmergencyOrder;
    const isAnnualReturnsOrder = order.properties?.isAnnualReturnsOrder;
    return (
        <>
            <GridItem {...styles.wrapper}>     
     <Typography {...styles.orderDate} aria-labelledby="orderType" data-test-selector="orderType">
        <strong>{translate("Order Type")}</strong>: {isEmergencyOrder?.toLocaleLowerCase() === "true"
             ? translate("Emergency Order")
             : isAnnualReturnsOrder?.toLocaleLowerCase() === "true"
                 ? translate("Annual Returns Order") : translate("Stock Order")}
     </Typography>
 </GridItem>

        </>
    );
};

const widgetModule: WidgetModule = {
    component: OrderType,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
